module.exports = __webpack_public_path__ + "images/guangxi_banner01.jpg?650f493637cecafd9d238c066ef4692b";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/guangxi_banner01.jpg
// module id = 184
// module chunks = 1